import LogInModel from '../models/login.model';
import router from '../../../../router/routes';
let storeContent = utils.generateStore({
	LogInModel,
	page: 1,
	router: null,
	expiry_date: new Date(),
	redirectPath: null,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
		setRedirectPath(state, path) {
			console.log('updating mutation redirect===##', path);
			state.redirectPath = path;
			console.log('start red', state.redirectPath);
		},
	},
	actions: {
		async sendOtp(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					await ctx.dispatch('sendOtpRequest', data.email);
					ctx.commit('page', 3);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async sendOtpRequest(ctx, username) {
			try {
				let res = await api.fetchEndpoint(
					{
						resource: 'forgot_password',
						action: 'request',
						data: { username },
					},
					'/home',
				);

				await $session.get('username', username);
				await $session.set(
					'password_change_request_id',
					res.result.password_change_request_id,
				);
				$notify(
					'success',
					'OTP Sent',
					`OTP has been sent to email or phone number provided`,
					10,
				);
			} catch (err) {
				throw err;
			}
		},
		async sendOtpRequestTwoFactor(ctx, username) {
			try {
				let res = await api.fetchEndpoint(
					{
						resource: 'forgot_password',
						action: 'request',
						data: { username },
					},
					'/home',
				);

				await $session.get('username', username);
				await $session.set(
					'password_change_request_id',
					res.result.password_change_request_id,
				);
				$notify(
					'success',
					'OTP Sent',
					`OTP has been sent to email or phone number provided`,
					10,
				);
			} catch (err) {
				throw err;
			}
		},
		async sendUsername(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'forgot_username',
							action: 'request',
							data: {
								username: data.email,
							},
						},
						'/home',
					);

					$notify(
						'success',
						'Username Sent',
						`Your username has been sent to email or phone number provided`,
						10,
					);
					ctx.commit('page', 6);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async continueOnDevice(ctx, payload) {
			try {
				ctx.commit('loading', true);
				// let data = payload.ref.formData_

				// if (await payload.ref.isValid()) {
				//    let res = await api.fetchEndpoint({
				//       resource: "forgot_username",
				//       action: "request",
				//       data: {
				//          username: data.email,
				//       }
				//    }, '/home')

				//    $notify('success', 'Username Sent', `Your username has been sent to email or phone number provided`, 10)
				//    ctx.commit('page', 6)
				// }
				await ctx.dispatch('completeLogIn');

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async logOutDevice(ctx, payload) {
			try {
				ctx.commit('loading', true);

				// Logout logic
				await ctx.dispatch('logOutUser');
				await $session.clear();
				Event.$emit('auth:logout', true);
				ctx.getters.router.push({ name: 'Home' });
				ctx.commit('page', 1);
				Event.$emit('auth:show', { login: false });

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async resendOTP(ctx) {
			try {
				ctx.commit('loading', true);
				let username = await $session.get('username');

				if (username) {
					await ctx.dispatch('sendOtpRequest', username);
				} else {
					$notify(
						'warning',
						'Username Error',
						`Username not found`,
						5,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async validateOTP(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let password_change_request_id = await $session.get(
						'password_change_request_id',
					);
					let res = await api.fetchEndpoint(
						{
							resource: 'forgot_password',
							action: 'validation',
							data: {
								password_change_request_id,
								code: data.otp,
							},
						},
						'/home',
					);

					$notify(
						'success',
						'OTP Verified',
						`OTP successfully Verified`,
						10,
					);
					ctx.commit('page', 4);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async resendOTPTwoFactor(ctx) {
			try {
				ctx.commit('loading', true);
				let username = await $session.get('username');

				if (username) {
					await ctx.dispatch('sendOtpRequestTwoFactor', username);
				} else {
					$notify(
						'warning',
						'Username Error',
						`Username not found`,
						5,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async validateOTPTwoFactor(ctx, payload) {
			try {
				ctx.commit('loading', true);
				// let data = payload.ref.formData_

				// if (await payload.ref.isValid()) {
				//    let password_change_request_id = await $session.get('password_change_request_id')
				//    let res = await api.fetchEndpoint({
				//       resource: "forgot_password",
				//       action: "validation",
				//       data: {
				//          password_change_request_id,
				//          code: data.otp
				//       }
				//    }, '/home')

				//    $notify('success', 'OTP Verified', `OTP successfully Verified`, 10)
				//    ctx.commit('page', 4)
				// }

				await ctx.dispatch('completeLogIn');

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async resetPassword(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;
				let user = await $session.get('otpUser');

				if (data.new_password !== data.confirmPassword) {
					$notify(
						'warning',
						'Validation Error',
						`Password does not match Confirm Password.`,
						10,
					);
					ctx.commit('loading', false);
					return false;
				}

				if (await payload.ref.isValid()) {
					let password_change_request_id = await $session.get(
						'password_change_request_id',
					);
					let res = await api.fetchEndpoint(
						{
							resource: 'forgot_password',
							action: 'change',
							data: {
								password_change_request_id,
								password: data.new_password,
							},
						},
						'/home',
					);

					$notify(
						'success',
						'Password Reset',
						`Password Reset Successful. Log in using your new password.`,
						10,
					);
					location.reload();
					ctx.commit('page', 1);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async resetExpiredPassword(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;
				let user = await $session.get('otpUser');

				if (data.new_password !== data.confirmPassword) {
					$notify(
						'warning',
						'Validation Error',
						`Password does not match Confirm Password.`,
						10,
					);
					ctx.commit('loading', false);
					return false;
				}

				if (await payload.ref.isValid()) {
					// let password_change_request_id = await $session.get('password_change_request_id')
					// let res = await api.fetchEndpoint({
					//    resource: "forgot_password",
					//    action: "change",
					//    data: {
					//       password_change_request_id,
					//       password: data.new_password
					//    }
					// }, '/home')

					// $notify('success', 'Password Reset', `Password Reset Successful. Log in using your new password.`, 10)
					// location.reload()
					// ctx.commit('page', 1)
					await ctx.dispatch('completeLogIn');
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		checkUserStatus(ctx, results) {
			try {
			} catch (err) {
				errHandler.handleError(err);
			}
		},
		addSchoolRoutes(ctx, user) {
			try {
				// if(user){
				console.log('Showing School Menu');
				// }
			} catch (err) {
				errHandler.handleError(err);
			}
		},
		async userLogIn(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = utils.parseData(ctx.getters.LogInModel.forms.login);

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'login',
							action: 'login',
							data: {
								username: data.username,
								password: data.password,
								trust_device: data.trust,
								device_details: {
									device_type: 'CHROME',
									device_category: 'WEB',
									device_version: 'V1',
									device_name: 'CHROME',
									device_uuid: '1223455',
								},
							},
						},
						'/home',
					);

					await $session.set('token', res.result.token);
					let user = Object.assign({}, res.result.user_details, {
						client_details: res.result.client_details,
					});
					await ctx.dispatch('addSchoolRoutes', user);
					await $session.set('user', user);
					await $session.set('client', res.result.client_details);

					//  disabled chat login
					//  await ctx.dispatch('chatLogIn')

					let quotation_details =
						await $session.get('quotation-item');

					// check if the user has profile details
					if (quotation_details) {
						if (quotation_details) {
							Event.$emit('requirements:show', {
								is_saved: true,
							});
						}
					} else if (
						res.result &&
						res.result.user_details.client_profile_status
					) {
						// if (['PENDING',''].includes(user.client_details.kyc_status)){
						//    payload.router.push({ name: 'ProfileSetup' })
						//    ctx.commit('loading', false)
						//    Event.$emit('auth:show', { login: false })
						//    return true
						// }

						const quoID = localStorage.getItem('quoID');
						const recquoID = localStorage.getItem('recquoID');

						//   const redirectPath = `/client-quotation-summary/${quotationID}`  || '/main/user';
						const redirectPath =
							`/client-kyc-details/${recquoID}/${quoID}` ||
							'/main/user';

						ctx.commit('router', payload.router);
						if (
							res.result.user_details.password_expiry &&
							res.result.user_details.password_expiry.status
						) {
							ctx.commit('page', 7);
							ctx.commit(
								'expiry_date',
								res.result.user_details.password_expiry
									.expiry_date,
							);
							ctx.commit('loading', false);
							return true;
						}

						if (
							res.result.user_details.two_factor_authentication &&
							res.result.user_details.two_factor_authentication
								.enabled
						) {
							ctx.commit('page', 8);
							ctx.commit('loading', false);
							return true;
						}

						if (
							res.result.user_details.already_logged_in &&
							res.result.user_details.already_logged_in.status
						) {
							ctx.commit('page', 9);
							ctx.commit('loading', false);
							return true;
						}

						if (
							['PENDING', ''].includes(
								user.client_details.self_assessment_status,
							)
						) {
							payload.router.push({ name: 'ConfirmAssessment' });
						} else {
							// payload.router.push({ name: 'Dashboard' })
							// payload.router.push('/dashboard');
							payload.router.push({
								path: ctx.state.redirectPath,
							});
							// router.push(state.redirectPath);
							console.log('ROUTER===', payload.router);
						}
					} else {
						payload.router.push({ name: 'ConfirmProfile' });
					}

					Event.$emit('auth:show', { login: false });
				}

				ctx.commit('loading', false);
			} catch (err) {
				errHandler.handleError(err);
				ctx.commit('loading', false);
			}
		},
		async completeLogIn(ctx, step) {
			console.log('completing logging===');
			try {
				let user = await $session.get('user', user);

				// if(!ctx.getters.router){
				//    await ctx.dispatch('logOutUser')
				//    await $session.clear()
				//    Event.$emit('auth:logout', true)
				//    ctx.getters.router.push({name: 'LandingPage'})
				//    return true
				// }

				if (
					user.password_expiry &&
					user.password_expiry.status &&
					ctx.getters.page < 7
				) {
					ctx.commit('page', 7);
					ctx.commit('expiry_date', user.password_expiry.expiry_date);
					ctx.commit('loading', false);
					return true;
				}

				if (
					user.two_factor_authentication &&
					user.two_factor_authentication.enabled &&
					ctx.getters.page < 8
				) {
					ctx.commit('page', 8);
					ctx.commit('loading', false);
					return true;
				}

				if (
					user.already_logged_in &&
					user.already_logged_in.status &&
					ctx.getters.page < 9
				) {
					ctx.commit('page', 9);
					ctx.commit('loading', false);
					return true;
				}

				const quotationID = localStorage.getItem('quotationID');
				const quoID = localStorage.getItem('quoID');
				const recquoID = localStorage.getItem('recquoID');

				//   const redirectPath = `/client-quotation-summary/${quotationID}`  || '/main/user';
				const redirectPath =
					recquoID && quoID
						? `/client-kyc-details/${recquoID}/${quoID}`
						: '/newportal';
				console.log('RIDERECT PATH===', redirectPath);

				// if (['PENDING', ''].includes(user.client_details.self_assessment_status)) {
				//    ctx.getters.router.push({ name: 'ConfirmAssessment' })
				// } else {
				//   // ctx.getters.router.push({ name: 'Dashboard' })
				//   //ctx.getters.router.push({ path: redirectPath });
				//   router.push({ path: redirectPath });
				// }

				router.push({ path: redirectPath });

				ctx.commit('page', 1);
				Event.$emit('auth:show', { login: false });
			} catch (error) {
				console.log(error);
				errHandler.handleError(error);
			}
		},
		async chatLogIn(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'chat',
						action: 'user_login',
						data: {},
					},
					'/client',
				);

				ctx.commit('chat_id', res.result.chat_user_identification);
				await $session.set(
					'chat_id',
					res.result.chat_user_identification,
				);
				ctx.getters.socket.emit('user:connected', {
					chat_user_identification:
						res.result.chat_user_identification,
				});
			} catch (error) {
				errHandler.handleError(error);
			}
		},
		async updateRedirectPath(ctx, path) {
			console.log('updating redirect=', path);
			try {
				// Optional: Validate or transform the path
				const redirectPath = path || '/dashboard';
				if (!redirectPath.startsWith('/')) {
					throw new Error('Invalid redirect path');
				}
				console.log('Setting redirect path:', redirectPath);
				ctx.commit('setRedirectPath', redirectPath);
			} catch (err) {
				console.error('Error setting redirect path:', err);
				throw err;
			}
		},
	},
};
